module.exports = __webpack_public_path__ + "static/media/welcome.477d5811.gif";